import { useStore } from '../../UploadChannelPkg/store'

const useUploadConfirm = props => {
    const [store] = useStore()
    const { pkgUploadStatus } = store
    const { successRecords, failedRecords } = pkgUploadStatus

    return { successRecords, failedRecords }
}

export default useUploadConfirm
